export default __webpack_public_path__ + "static/media/bmw-series-complete-large.b81bf0a0.svg";